import { App } from 'vue'
import element from './element'
import head from './head'
import permissions from './permissions/index'
import ddErrorHandler from './dd-error-handler/dd-error-handler.plugin'
import bodyScroll from './body-scroll'
import deviceInfo from './device-info/index'
import calendar from './calendar'
import mediaQueries from './media-queries'
import ddStrings from './dd-strings/dd-strings.plugin'
import pusher from './pusher'
import frill from './frill'
/* dd-extensions depend on the plugins above */
import elementDdExtension from './dd-extensions/element-dd-extension/index'
import vueMqDdExtension from './dd-extensions/vue-mq-dd-extension/index'

export default function installPlugins(app: App) {
  app.use(element)
  app.use(head)
  app.use(permissions)
  app.use(ddErrorHandler)
  app.use(bodyScroll)
  app.use(deviceInfo)
  app.use(calendar)
  app.use(mediaQueries)
  app.use(ddStrings)
  app.use(pusher)
  app.use(frill)
  app.use(elementDdExtension)
  app.use(vueMqDdExtension)
}
